import { render, staticRenderFns } from "./VendorDashboardView.vue?vue&type=template&id=53157e1c&"
import script from "./VendorDashboardView.vue?vue&type=script&lang=js&"
export * from "./VendorDashboardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports